
  import { css } from 'lit';
  export const styles = css`[part~=helper-text]{color:var(--helper-text-color);row-gap:.5rem}[part~=validation-icon]{color:var(--icon-error-color)}[part~=validation-message]{gap:.25rem;color:var(--text-error-color)}`;
  